import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { useCurrency } from '../context/CurrencyContext';

const NAMES = { USD: 'US Dollar', AUD: 'Australian Dollar', GBP: 'British Pound', EUR: 'Euro' };

const CurrencySwitcher = () => {
  const { code, symbol, currencies, setCode } = useCurrency();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button data-testid="currency-switcher" onClick={() => setOpen(o => !o)} aria-haspopup="listbox" aria-expanded={open} aria-label="Change currency"
        className="inline-flex items-center gap-1 h-9 px-2.5 rounded-full border border-neutral-200 dark:border-neutral-700 text-[12.5px] font-semibold text-neutral-700 dark:text-neutral-200 hover:border-brand transition-colors">
        <span className="text-brand">{symbol}</span><span className="hidden sm:inline">{code}</span>
        <ChevronDown size={12} className={`text-neutral-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div role="listbox" data-testid="currency-menu" className="absolute -left-2 sm:left-auto sm:right-0 top-[calc(100%+6px)] z-50 w-52 rounded-xl border border-neutral-200 dark:border-neutral-800 bg-white dark:bg-[#141416] shadow-2xl p-1 page-fade-in">
          {currencies.map(c => (
            <button key={c.code} role="option" aria-selected={c.code === code} data-testid={`currency-option-${c.code}`}
              onClick={() => { setCode(c.code); setOpen(false); }}
              className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left text-[13px] transition-colors ${c.code === code ? 'bg-brand-soft text-brand' : 'hover:bg-neutral-50 dark:hover:bg-neutral-900 text-neutral-700 dark:text-neutral-200'}`}>
              <span className="w-7 font-semibold">{c.symbol}</span>
              <span className="flex-1"><span className="font-medium">{c.code}</span> <span className="text-[11.5px] text-neutral-500">{NAMES[c.code]}</span></span>
              {c.code === code && <Check size={14} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CurrencySwitcher;
